export const FacilityIcon = ({
  className,
  strokeColor = 'currentColor',
}: {
  className?: string
  strokeColor?: string
}) => (
  <svg
    className={className}
    height='48'
    viewBox='0 0 48 48'
    width='48'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g>
      <path d='M0 0h48v48H0V0z' fill='none' />
      <path
        d='M6 42h36'
        fill='none'
        stroke={strokeColor}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='3'
      />
      <path
        d='M18 16h2'
        fill='none'
        stroke={strokeColor}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='3'
      />
      <path
        d='M18 24h2'
        fill='none'
        stroke={strokeColor}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='3'
      />
      <path
        d='M18 32h2'
        fill='none'
        stroke={strokeColor}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='3'
      />
      <path
        d='M28 16h2'
        fill='none'
        stroke={strokeColor}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='3'
      />
      <path
        d='M28 24h2'
        fill='none'
        stroke={strokeColor}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='3'
      />
      <path
        d='M28 32h2'
        fill='none'
        stroke={strokeColor}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='3'
      />
      <path
        d='M10 42V10c0-2.209139 1.790861-4 4-4h20c2.209139 0 4 1.790861 4 4v32'
        fill='none'
        stroke={strokeColor}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='3'
      />
    </g>
  </svg>
)
